<template>
  <div>
    <BannerNotice
      v-if="showFileErrorBanner > 0"
      :message="failedFileUploadMessage"
    />
    <NominateForm
      ref="NominateForm"
      class="content"
      :nomination-id="nominationId"
      :prefill-form-data="prefillFormData"
      :uploaded-files="uploadedFiles"
      submit-label="Save Changes"
      @files-changed="getUploadedFiles"
      @submit="submit"
    />
  </div>
</template>

<script>
import NominateForm from '@/components/NominateForm'
import BannerNotice from '@/components/BannerNotice'
import { updateNomination, getNomination, getNominationFiles } from '@/services/HttpSvc'
import { USER_NOMINATIONS } from '@/core/constants'

const nominationId = Number(location.pathname.split('/')[4])
const showFileErrorBanner = Number(new URLSearchParams(window.location.search).get('fileUploadFailed'))

export default {
  name: 'EditNomination',

  components: {
    NominateForm,
    BannerNotice,
  },

  data() {
    return {
      nominationId,
      showFileErrorBanner,
      failedFileUploadMessage: 'One or more files failed to upload. Your nomination was saved successfully. Try uploading your file attachement(s) again.',
      prefillFormData: {},
      uploadedFiles: [],
    }
  },

  async created() {
    if (this.nominationId) {
      this.getNomination()
      this.getUploadedFiles()
    }
  },

  mounted() {
    // remove the query parameters so the banner doesn't continue to show up
    if(showFileErrorBanner && window.location.search.substring(1).length) {
       window.history.pushState({}, document.title, window.location.pathname);
    }
  },

  methods: {
    async submit(formData) {
      try {
        await updateNomination(formData)
        const uploadFilesResp = await this.$refs.NominateForm.uploadFiles()

        if (uploadFilesResp.failed.length >= 1) {
          //console.error('File upload failed! uploadFilesResp: ', uploadFilesResp)
        } else {
          //console.debug('File upload success! uploadFilesResp: ', uploadFilesResp)
          window.location = USER_NOMINATIONS
        }
      } catch(err) {
        //console.error('nomination failed', err)
      }
    },

    async getUploadedFiles() {
      this.uploadedFiles = await getNominationFiles(this.nominationId)
    },

    async getNomination() {
      this.prefillFormData = await getNomination(this.nominationId)
    },

  },
}
</script>
